import { Checkbox } from '@mui/material';
import Text from '../../../components/atoms/Text';
import Button from '../../../components/atoms/Button';

type ApprovalType = 'automatic' | 'manual';

interface ApprovalTypeSelectorProps {
	approvalType: ApprovalType;
	onApprovalTypeChange: (type: ApprovalType) => void;
	onSave: () => void;
	isSaving: boolean;
}

const ApprovalTypeSelector = ({
	approvalType,
	onApprovalTypeChange,
	onSave,
	isSaving,
}: ApprovalTypeSelectorProps) => {
	return (
		<div className='w-full h-full p-4 bg-[#FBFDFF] rounded-lg outline outline-1 outline-[#1790EC] outline-offset-[-1px] flex flex-col justify-start items-start gap-6 mt-4'>
			<div className='flex flex-col justify-start items-start gap-1'>
				<Text weight='bold' size='body-3'>Elige cómo presentar tu declaración</Text>
				<Text weight='regular' size='caption'>Selecciona la forma en que prefieres que manejemos tus declaraciones.</Text>
			</div>
			<div className='self-stretch flex flex-col justify-start items-start gap-2'>
				<div className={`self-stretch px-2 py-2.5 ${approvalType === 'automatic' ? 'bg-[#F4F9FE] outline-[#1790EC]' : 'outline-[#E6E6E6]'} rounded-lg outline outline-1 outline-offset-[-1px] flex flex-col justify-center items-start gap-4`}>
					<div className='flex justify-start items-center gap-2.5'>
						<Checkbox
							checked={approvalType === 'automatic'}
							onChange={() => onApprovalTypeChange('automatic')}
							sx={{
								color: '#1790EC',
								'&.Mui-checked': {
									color: '#1790EC',
								},
								padding: 0,
								'& .MuiSvgIcon-root': {
									fontSize: 16,
								},
							}}
						/>
						<div className='flex flex-col justify-start items-start gap-0'>
							<Text weight='bold' size='caption'>Presentación automatica</Text>
							<Text weight='regular' size='mini-1'>Calculamos y presentamos automáticamente tu declaración al SAT.</Text>
						</div>
					</div>
				</div>
				<div className={`self-stretch px-2 py-2.5 ${approvalType === 'manual' ? 'bg-[#F4F9FE] outline-[#1790EC]' : 'outline-[#E6E6E6]'} rounded-lg outline outline-1 outline-offset-[-1px] flex flex-col justify-center items-start gap-4`}>
					<div className='flex justify-start items-center gap-2'>
						<Checkbox
							checked={approvalType === 'manual'}
							onChange={() => onApprovalTypeChange('manual')}
							sx={{
								color: '#1790EC',
								'&.Mui-checked': {
									color: '#1790EC',
								},
								padding: 0,
								'& .MuiSvgIcon-root': {
									fontSize: 16,
								},
							}}
						/>
						<div className='flex flex-col justify-start items-start gap-0'>
							<Text weight='bold' size='caption'>Aprobar mi declaración</Text>
							<Text weight='regular' size='mini-1'>Te mostramos los cálculos antes de presentar tu declaración al SAT.</Text>
						</div>
					</div>
				</div>
			</div>
			<Button
				variant='secondary'
				label='Guardar mi decisión'
				onClick={onSave}
				loading={isSaving}
			/>
		</div>
	);
};

export default ApprovalTypeSelector; 